var ApplicantAPI = require('../../../common/api').Applicant;

module.exports = function FundraisingOfferController($scope){

  $scope.vm = this;
  
  var init = function() {
  }
 
  init();
}
